import { useField } from "formik";

import {
  InputWrapper,
  InputWrapperProps,
} from "../components/inputs/_assets/input-wrapper/InputWrapper";
import { TextAreaProps } from "../components/inputs/text-area/TextArea";

import { EmailSelector } from "../components/inputs/email-selector/EmailSelector";
interface Props
  extends InputWrapperProps,
    Omit<
      TextAreaProps,
      "onChange" | "errorMessage" | "validationState" | "value"
    > {
  name: string;
  label?: string;
  testID: string;
  span?: InputWrapperProps["span"];
  max?: number;
}

export function EmailSelectorField({
  name,
  span = "auto",
  testID = "email-list-area-field",
  ...restProps
}: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <EmailSelector
        {...restProps}
        errors={meta.touched ? meta.error : undefined}
        value={field.value}
        isInvalid={Boolean(meta.touched && meta.error)}
        testID={testID}
        onChange={helpers.setValue}
      />
    </InputWrapper>
  );
}
